import type TableView from '../store/schema/TableView';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

// IMPORTANT: This only determines whether the mail list is in conversation view or not.
// To determine if the reading pane is in conversation view, please use the util
// import { isReadingPaneStackedView } from 'owa-mail-organization-settings/lib/utils/readingPaneStackedViewUtils';
export default function isMailListConversationView(tableView: TableView): boolean {
    return tableView?.tableQuery?.listViewType === 0;
}
